import { ComponentButton } from './ComponentButton';
import { ActionButton as ActionButtonType } from '@/schemas/sceneDataSchema';
import { useAction } from '@/hooks/use-action';
import { RouteFn } from '@/hooks/use-flow';

export const ActionButton = ({ component, route }: { component: ActionButtonType; route: RouteFn }) => {
  const { executeAction } = useAction();

  const onClick = () => {
    executeAction(component.action, component.arguments ?? {}, route);
  };

  return (
    <ComponentButton
      onClick={onClick}
      component={component}
      type='button'
    />
  );
};
